import React from "react";
import { BsGithub, BsInstagram, BsLinkedin, BsTwitter } from "react-icons/bs";

function Social() {
  return (
    <div className="social-container flex flex-col items-center gap-6 py-10 text-2xl text-header-color sm:flex-row sm:justify-center sm:gap-10">
      <a
        href="https://github.com/josuerushanika"
        target="_blank"
        rel="noreferrer"
        aria-label="GitHub profile"
        className="transition-transform hover:-translate-y-1 hover:text-white"
      >
        <BsGithub className="social-icon" />
      </a>
      <a
        href="https://www.linkedin.com/in/josuerushanika/"
        target="_blank"
        rel="noreferrer"
        aria-label="LinkedIn profile"
        className="transition-transform hover:-translate-y-1 hover:text-white"
      >
        <BsLinkedin className="social-icon" />
      </a>
      <a
        href="https://twitter.com/josuerushanika"
        target="_blank"
        rel="noreferrer"
        aria-label="Twitter profile"
        className="transition-transform hover:-translate-y-1 hover:text-white"
      >
        <BsTwitter className="social-icon" />
      </a>
      <a
        href="https://www.instagram.com/josue_rushanika/"
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram profile"
        className="transition-transform hover:-translate-y-1 hover:text-white"
      >
        <BsInstagram className="social-icon" />
      </a>
    </div>
  );
}

export default Social;
